import React from "react";
import PropTypes from "prop-types";

/**
 * DC Keeper 字標(客戶提供的 SVG 原件,2026-08-03 置於 public/images/)。
 *
 * - variant="full" :`dckeeper-logo.svg`(140×26,白字)— 側欄展開時
 * - variant="mark" :`dckeeper-logo_s.svg`(44×21,白字「DC」)— 側欄收合成窄軌時
 * - variant="color":`dckeeper-logo_colorful.svg`(140×26,黃#FED72F+淺藍#91D2E5)
 *                   — 密碼/認證卡片等白底畫面(Figma logo_彩色 29:2990)
 *
 * 原本是單色 path 走 currentColor 的內嵌 SVG;客戶提供原件後改直接引檔,
 * 顏色以原件為準,不再由外層 color 決定。
 */
const VARIANTS = {
  full: { file: "dckeeper-logo.svg", ratio: 140 / 26 },
  mark: { file: "dckeeper-logo_s.svg", ratio: 44 / 21 },
  color: { file: "dckeeper-logo_colorful.svg", ratio: 140 / 26 },
};

export const DckLogo = ({ height = 25.27, variant = "full", className, title = "DC Keeper" }) => {
  const { file, ratio } = VARIANTS[variant] || VARIANTS.full;
  return (
    <img
      src={`${process.env.PUBLIC_URL}/images/${file}`}
      height={height}
      width={+(height * ratio).toFixed(2)}
      alt={title}
      className={className}
      style={{ display: "block" }}
    />
  );
};

DckLogo.propTypes = {
  height: PropTypes.number,
  variant: PropTypes.oneOf(["full", "mark", "color"]),
  className: PropTypes.string,
  title: PropTypes.string,
};

export default DckLogo;
